import { render } from "./LicenzaBanner.vue?vue&type=template&id=39d65566&scoped=true"
import script from "./LicenzaBanner.vue?vue&type=script&lang=js"
export * from "./LicenzaBanner.vue?vue&type=script&lang=js"

import "./LicenzaBanner.vue?vue&type=style&index=0&id=39d65566&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d65566"]])

export default __exports__